module.exports = __webpack_public_path__ + "static/media/stripe_logo.63470dff.svg";